import { string, bool, shape, number, arrayOf, oneOfType } from 'prop-types';

const selectOptionPropTypes = shape({
  value: oneOfType([number, string, bool]),
  label: string,
  code: string,
});

const preventiveTaskResumePropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  companyPreventiveTaskId: string,
  description: string,
  actionType: string,
  active: bool,
  priority: string,
  deviation: number,
  repeatType: string,
  repeatInterval: number,
};

const companyResourcePropTypes = {
  id: number.isRequired,
  name: string.isRequired,
};

const executionUserPropTypes = {
  id: number.isRequired,
  username: string,
  fullName: string,
};

const preventiveTaskExecutionResourcePropTypes = {
  id: number,
  preventiveTaskExecutionId: number,
  resourceId: number.isRequired,

  companyResource: shape(companyResourcePropTypes),

  startedDate: number,
  completedDate: number,

  status: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  comment: string,
  createDate: number,
  lastUpdate: number,
};

const preventiveTaskExecutionResourceDefaultProps = {
  id: null,
  preventiveTaskExecutionId: null,
  companyResource: null,
  startedDate: null,
  completedDate: null,
  comment: null,
  createDate: null,
  lastUpdate: null,
};

const preventiveTaskExecutionBasicInformationPropTypes = {
  id: number.isRequired,

  preventiveTaskId: number.isRequired,

  preventiveTask: shape(preventiveTaskResumePropTypes),

  preventiveTaskAssigneeId: number.isRequired,

  preventiveTaskProjectionId: number,

  scheduleDate: number,

  startedDate: number,

  completedDate: number,

  status: oneOfType([string, number, selectOptionPropTypes]).isRequired,

  resourceExecutionMode: oneOfType([string, number, selectOptionPropTypes])
    .isRequired,

  executorUserId: number,

  user: shape(executionUserPropTypes),

  comment: string,

  createDate: number,

  lastUpdate: number,
};

const preventiveTaskExecutionBasicInformationDefaultProps = {
  preventiveTask: null,
  preventiveTaskProjectionId: null,
  scheduleDate: null,
  startedDate: null,
  completedDate: null,
  executorUserId: null,
  user: null,
  comment: null,
  createDate: null,
  lastUpdate: null,
};

const preventiveTaskExecutionFullInformationPropTypes = {
  ...preventiveTaskExecutionBasicInformationPropTypes,

  preventiveTaskProjection: shape({}),

  preventiveTaskExecutionResourceList: arrayOf(
    shape(preventiveTaskExecutionResourcePropTypes),
  ),
};

const preventiveTaskExecutionFullInformationDefaultProps = {
  ...preventiveTaskExecutionBasicInformationDefaultProps,
  preventiveTaskProjection: null,
  preventiveTaskExecutionResourceList: [],
};

const preventiveTaskExecutionFormPropTypes = {
  preventiveTaskId: oneOfType([number, string, selectOptionPropTypes]),

  preventiveTaskProjectionId: oneOfType([
    number,
    string,
    selectOptionPropTypes,
  ]),

  scheduleDate: oneOfType([number, string]),

  startedDate: oneOfType([number, string]),

  completedDate: oneOfType([number, string]),

  status: oneOfType([string, number, selectOptionPropTypes]),

  resourceExecutionMode: oneOfType([string, number, selectOptionPropTypes]),

  executorUserId: oneOfType([number, string, selectOptionPropTypes]),

  comment: string,

  resources: arrayOf(
    shape({
      resourceId: oneOfType([number, string, selectOptionPropTypes]),
      companyResource: shape(companyResourcePropTypes),
      startedDate: oneOfType([number, string]),
      completedDate: oneOfType([number, string]),
      status: oneOfType([string, number, selectOptionPropTypes]),
      comment: string,
    }),
  ),
};

const preventiveTaskExecutionFormDefaultProps = {
  preventiveTaskId: null,
  preventiveTaskProjectionId: null,
  scheduleDate: null,
  startedDate: null,
  completedDate: null,
  status: null,
  resourceExecutionMode: null,
  executorUserId: null,
  comment: null,
  resources: [],
};

export {
  selectOptionPropTypes,
  preventiveTaskResumePropTypes,
  companyResourcePropTypes,
  executionUserPropTypes,
  preventiveTaskExecutionResourcePropTypes,
  preventiveTaskExecutionResourceDefaultProps,
  preventiveTaskExecutionBasicInformationPropTypes,
  preventiveTaskExecutionBasicInformationDefaultProps,
  preventiveTaskExecutionFullInformationPropTypes,
  preventiveTaskExecutionFullInformationDefaultProps,
  preventiveTaskExecutionFormPropTypes,
  preventiveTaskExecutionFormDefaultProps,
};
